export const safeJsonParse = <T = any>(objStr: string): T | null => {
  try {
    return JSON.parse(objStr) as T;
  } catch {
    return null;
  }
};
